import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';
import Breadcrumb, {
  BreadcrumbItem,
} from 'modules/_shared/components/Breadcrumb';
import { State } from 'redux/initialState';

const SocietyAiAgentHeader: FC = () => {
  const { t } = useTranslate();
  const { societyId } = useParams<{ societyId: string }>();
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const societyName = actualSociety?.name || '';

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('Dashboard'), to: '/' },
      { label: societyName, to: `/sociedad/${societyId}` },
      { label: t('CHATBOT_NaviAgent'), isActive: true },
    ],
    [t, societyName, societyId]
  );

  return (
    <div className="navi-page-header">
      <Breadcrumb items={breadcrumbItems} />
    </div>
  );
};

export default SocietyAiAgentHeader;
